import React from 'react';
import ReactDOM from 'react-dom/client';

let App;

if (process.env.REACT_APP_APP_TARGET === 'backoffice') {
  require('./backoffice/styles.css');
  App = require('./backoffice/App').default;
} else {
  require('./index.css');
  App = require('./App').default;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
